<template>
    <div class="main-footer">

        <footer v-cloak>
            <div class="container">
                <p class="footer-copyright">
                    &copy; {{ year }} wellcoaches HEALTHCARE<span class="footer-copyright__divider">-</span><span class="footer-copyright__who-credit">portions &copy; 2001, 2002 World Health Organization</span>
                    <img class="diet-id-badge" src="/../../images/Diet_ID_badge.png" alt="Diet ID badge">
                </p>

                <b-nav class="footer-nav">
                    <b-nav-item to="/" :disabled="isHomeDisabled">
                        {{ $i18n.gt('LABEL_HOME') }}
                    </b-nav-item>
                    <li>|</li>
                    <b-nav-item to="/privacy" :disabled="isPrivacyDisabled">
                        {{ $i18n.gt('LABEL_PRIVACY') }}
                    </b-nav-item>
                </b-nav>
            </div>
            <!--<div class="footer-logos">
                <div class="partner-logos footer-logo">
                </div>
            </div>-->
        </footer>

    </div>
</template>

<script>

    import Vue from 'vue'

    export default Vue.extend({
        name: "MainFooter",
        computed: {
            year() {
                return new Date().getFullYear()
            },
            isHomeDisabled() {
                return (this.$route.name === 'home') ? 'disabled' : null
            },
            isPrivacyDisabled() {
                return (this.$route.name === 'privacy') ? 'disabled' : null
            }
        }
    })
</script>

<style lang="scss">

    .main-footer {
        //padding-bottom: 48px;
    }

    footer {
        border-top: solid 1px #E5E9EC;
        //@include box-shadow(0 0 20px rgba(0,0,0,.1));
        padding-bottom: 1em;
        text-align: center;
        font-size: 14px!important;
        background-color: #fff;

        > .container {
            padding: .75em 1em;
            //border-top: solid 1px #D5D7D9;
            @media (min-width:1024px) {
                display:flex;
                justify-content: space-between;
                align-items: center;
                .footer-nav {
                    margin-right:40px;
                }
            }
        }
    }

    .footer-nav {
        display: flex;
        justify-content: center;
        font-weight: 300;
        font-size: 18px;
        color: #ddd;

        li {
            line-height: 30px;
        }

        a {
            padding: 0 1em;
            font-size: 11px;
            text-transform: uppercase;
        }
    }

    .footer-logos {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 1em 1em;
        background-color: #fff;
    }

    .footer-logo {
        margin: 0 1em;
    }

    p.footer-copyright {
        color: #aaa;
        font-weight: 300;
        font-size: 13px;
        @media (min-width: 1024px) {
            margin-bottom: 0;
        }
    }

    .partner-logos {
        img {
            height: 20px;
        }
    }

    .footer-phone {
        @media (max-width: 480px) {
            display: block;
        }

        @media (min-width: 481px) {
            border-left: solid 1px #ddd;
            padding-left: 1em;
            margin-left: 1em;
        }
    }

    #root-app footer {
        background-color: #fff;
        position: relative;
        /*z-index: 1;*/
    }

    @media (max-width: 599px) {
        .footer-copyright__who-credit {
            font-size: 12px;
            display:block;
        }
    }

    .footer-copyright__divider {
        @media (max-width: 599px) {
            display: none;
        }
        @media (min-width: 600px) {
            margin: 0 10px;
        }
    }

    .diet-id-badge {
        height:96px;
        display: inline-block;
    }

</style>
